import React from 'lib/react';
import { EVButton, EVExitToAppOutlinedIcon, makeStyles } from 'lib/components';
import { useTranslation } from 'lib/translation';
import { Link } from 'lib/router';
import { ORDER_ROUTE } from 'constants/RouteConstants';
import { useSelector } from 'lib/redux';
import { VIEWPOINT_URL } from 'constants/AppConstants';
import Typography from 'commonComponents/typography';

const useStyles = makeStyles((theme) => ({
  signIn: {
    alignItems: 'center',
    padding: '0 20px',
    width: '100%',
    cursor: 'pointer',
    backgroundColor: theme.evPalette.salt[100],
    border: 'none',
    justifyContent: 'left',
    '&:hover': {
      backgroundColor: theme.evPalette.charcoal[100],
    },
    '&>.myev-MuiButton-label': {
      display: 'flex',
      gap: '20px',
    },
  },
}));
function SidebarLogInButton() {
  const { t } = useTranslation();
  const classes = useStyles();

  const geocodedAddress = useSelector(({ orderAddresses }) => orderAddresses.geocodedAddress);
  const addressParams = geocodedAddress ? `?latitude=${geocodedAddress.latitude}&longitude=${geocodedAddress.longitude}` : '';

  return (
    <EVButton
      id="signIn"
      type={Link}
      href={`${VIEWPOINT_URL}/myev${ORDER_ROUTE}${addressParams}`}
      className={classes.signIn}
      aria-label={t('LogIn')}
    >
      <EVExitToAppOutlinedIcon />
      <Typography>{t('unauthenticated__login_Btn')}</Typography>
    </EVButton>
  );
}

export default SidebarLogInButton;
